import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { cloneObjectWithPrefixedProperties } from '@noths/polaris-client-utils';
import * as styles from "./SvgIcon.styles";
export var SvgIcon = function SvgIcon(_ref) {
  var className = _ref.className,
    color = _ref.color,
    dataAttributes = _ref.dataAttributes,
    height = _ref.height,
    src = _ref.src,
    testId = _ref.testId,
    width = _ref.width;
  return /*#__PURE__*/React.createElement(_StyledSpan, _extends({
    className: className,
    style: {
      width,
      height
    }
  }, cloneObjectWithPrefixedProperties(dataAttributes, 'data-'), {
    $_css: styles.iconWrapper
  }), /*#__PURE__*/React.createElement(_StyledSpan2, {
    "data-testid": testId,
    style: {
      '--iconColor': color,
      '--iconImage': "url(\"".concat(src, "\")")
    },
    $_css2: [styles.icon]
  }));
};
var _StyledSpan = _styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSpan2 = /*#__PURE__*/_styled2("span").withConfig({
  displayName: "SvgIcon___StyledSpan2",
  componentId: "sc-2vt4br-0"
})(["", ""], function (p) {
  return p.$_css2;
});